import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import Pagination from 'components/Pagination';
import styles from './NeovarsityManagementPagination.module.scss';
import { setCurrentPage } from '@neovarsityManagement/store/capstoneSubmission';

function NeovarsityManagementPagination({ pageCount, currentPage }) {
  const dispatch = useDispatch();

  const handlePageChange = useCallback(
    (event) => {
      dispatch(setCurrentPage(event.selected + 1));
    },
    [dispatch]
  );

  return (
    <Pagination
      onPageChange={handlePageChange}
      pageCount={pageCount}
      forcePage={currentPage - 1}
      className={styles.paginate}
    />
  );
}

export default NeovarsityManagementPagination;
